/** Хост отдельного входа «физюра» (fizur.inforensic.dev / .pro). */
export const isFizurHost = (): boolean =>
  typeof window !== "undefined" && window.location.hostname.startsWith("fizur.");
